import { AuthenticationService } from 'src/api/authentication_service';
import { FakeMemberRepository } from 'src/api/fake_member_repository';
import { MemberRepository } from 'src/api/member_repository';
import { UserFieldsFragment, RoleFieldsFragment } from 'src/types';
import { DistributionPlatform } from 'src/types/env';
import {
  isClinicAdmin,
  isCustomerSuccess,
  isOrderingPhysician,
} from 'src/utils';

const MEMBERS_STORAGE_KEY = 'ldtMembers';
const INVITES_STORAGE_KEY = 'ldtInvites';

const CLINIC_ADMIN_ROLE: RoleFieldsFragment = {
  id: 'role_1',
  name: 'clinic-admin',
  description:
    'Creates, updates, deletes, and manages orders and members for their organization.',
};

const ORDERING_PHYSICIAN_USER_ROLE: RoleFieldsFragment = {
  id: 'role_2',
  name: 'ordering-physician',
  description: 'Read and write access to orders.',
};

const CUSTOMER_SUCCESS_ROLE: RoleFieldsFragment = {
  id: 'role_3',
  name: 'artera-customer-success',
  description:
    'All Artera member roles plus permission to validate fax numbers.',
};

const user1 = {
  userId: 'user_123456',
  email: 'john.doe@example.com',
  name: 'John Doe',
  givenName: 'John',
  familyName: 'Doe',
  roles: [CLINIC_ADMIN_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user2 = {
  userId: 'user_234567',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user3 = {
  userId: 'user_234568',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user4 = {
  userId: 'user_234569',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user5 = {
  userId: 'user_234510',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user6 = {
  userId: 'user_234511',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user7 = {
  userId: 'user_234512',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user8 = {
  userId: 'user_234513',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user9 = {
  userId: 'user_234514',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user10 = {
  userId: 'user_234515',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user11 = {
  userId: 'user_234516',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user12 = {
  userId: 'user_234517',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user13 = {
  userId: 'user_234518',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user14 = {
  userId: 'user_234519',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CUSTOMER_SUCCESS_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user15 = {
  userId: 'user_234520',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CUSTOMER_SUCCESS_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user16 = {
  userId: 'user_234521',
  email: 'jane.smith@example.com',
  name: 'Hello World',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const invitation1 = {
  id: 'inv_123456',
  email: 'new.user@example.com',
  expiresAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago (expired)
  createdAt: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(), // Created 9 days ago
  inviterName: 'John Doe',
  organizationId: 'org_123',
  roles: [ORDERING_PHYSICIAN_USER_ROLE],
};

/**
 * Implementation of the Member Repository for the Ldt platform on a fake backend.
 */
export class LdtFakeMemberRepository
  extends FakeMemberRepository
  implements MemberRepository
{
  readonly _platform = DistributionPlatform.Ldt;
  readonly _roles = [
    CLINIC_ADMIN_ROLE,
    ORDERING_PHYSICIAN_USER_ROLE,
    CUSTOMER_SUCCESS_ROLE,
  ];
  readonly _membersStorageKey = MEMBERS_STORAGE_KEY;
  readonly _invitationsStorageKey = INVITES_STORAGE_KEY;
  readonly _initialMembers = [
    user1,
    user2,
    user3,
    user4,
    user5,
    user6,
    user7,
    user8,
    user9,
    user10,
    user11,
    user12,
    user13,
    user14,
    user15,
    user16,
  ];
  readonly _initialInvitations = [invitation1];

  async getAssignableRoles(): Promise<RoleFieldsFragment[]> {
    const selectedOrganizationName =
      AuthenticationService.getInstance().getEffectiveOrganization().name;

    if (isClinicAdmin() || isOrderingPhysician()) {
      return [CLINIC_ADMIN_ROLE, ORDERING_PHYSICIAN_USER_ROLE];
    } else if (isCustomerSuccess()) {
      if (selectedOrganizationName === 'artera') {
        return [CUSTOMER_SUCCESS_ROLE];
      } else {
        return [CLINIC_ADMIN_ROLE, ORDERING_PHYSICIAN_USER_ROLE];
      }
    }

    throw new Error('User does not have a valid role');
  }
}
